<template>
  <div class="relative overflow-hidden">
    <!-- component -->
    <div class="md:p-4 flex justify-center">
      <div class="w-full lg:w-1/2">
        <div v-if="customer != null">
          <div class="bg-white md:shadow-xl mb-4 pb-6 justify-center border-solid border-t-4 border-green-600">
            <img class="mx-auto h-12 w-auto mt-4" :src="require('@/assets/img/logos/logo.png')" alt="Brandfi logo">
            <h2 class="mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900">
              Get connected to WiFi
            </h2>
            <div class="p-6  border-b" v-if="methods.includes('signup')">
              <SignUp :customer="customer" :token="token"/>
            </div>
            <div class="p-6 flex flex-col justify-between" v-if="methods.length > 0">
              <div class="grid  gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3">
                <button v-if="methods.includes('fb')" @click="login('/facebook/login')"
                        class="w-full bg-indigo-700 hover:shadow-xl shadow-lg hover:bg-indigo-800 text-white font-bold py-2 px-4 focus:outline-none"
                        type="button">
                  Connect with Facebook
                </button>
                <button v-if="methods.includes('google')" @click="login('/google/login')"
                        class="w-full bg-gray-400 hover:shadow-xl shadow-lg text-black font-bold  py-2 px-4 focus:outline-none"
                        type="button">Connect with Google
                </button>
                <button v-if="methods.includes('twitter')" @click="login('/twitter/login')"
                        class="w-full bg-blue-500 hover:shadow-xl shadow-lg  hover:bg-blue-600 text-white font-bold py-3 px-4 focus:outline-none"
                        type="button">Connect with Twitter
                </button>
                <button v-if="methods.includes('linkedin')" @click="login('/linkedin/login')"
                        class="w-full bg-teal-500 hover:shadow-xl shadow-lg hover:bg-teal-600 text-white font-bold py-3 px-4 focus:outline-none"
                        type="button">Connect with LinkedIn
                </button>
                <button @click="login('/ajira/login')" v-if="methods.includes('ajira')"
                        class="w-full bg-red-600 hover:shadow-xl shadow-lg hover:bg-red-700 text-white font-bold py-3 px-4 focus:outline-none"
                        type="button">Connect with Ajira Digital
                </button>
              </div>
            </div>
            <div class="pt-6 px-6" v-if="methods.includes('click')">
              <button @click="login('/click_through')"
                      class="mx-auto w-full lg:mx-0 text-white font-bold rounded-sm bg-teal-600 mt-3 py-3 px-8 shadow-md uppercase">
                Connect
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import SignUp from "@/customer/SignUp";

export default {
  name: 'ConnectToWifi',
  components: { SignUp},
  props: {},
  data() {
    return {
      loading: false,
      connection: null,
      customer: null,
      token: '',
      methods: []
    }
  },
  mounted() {
    this.token = this.$route.query.token;
    this.getConnection()
  },
  methods: {
    getConnection() {
      this.axios.get(process.env.VUE_APP_SPLASH_URL + '/connection/' + this.token).then((result) => {
        this.connection = result.data.connection;
        this.customer = result.data.customer;
      }).finally(() => {
        if (this.connection.authorizedAt != null)
          this.$root.$emit('alert_error', ["Connection has already been authorized", "Reconnect to WiFi for a new connection session"]);
        else
          this.getAppropriateMethod()
      })
    },
    getAppropriateMethod() {
      if (this.customer.emailAddress == null || this.customer.phoneNumber == null || this.customer.firstName == null || this.customer.lastName == null)
        this.methods.push('signup')
      // if (this.customer.facebook == null)
      //   this.methods.push('fb')
      // if (this.customer.twitter == null)
      //   this.methods.push('twitter')
      // if (this.customer.linkedin == null)
      //   this.methods.push('linkedin')
      // if (this.customer.google == null)
      //   this.methods.push('google')
      // if (this.customer.emailAddress == null) {
      //   this.methods.push('linkedin')
      //   this.methods.push('google')
      //   this.methods.push('twitter')
      //   this.methods.push('ajira')
      // }
      // if (this.customer.phoneNumber == null)
      //   this.methods.push('ajira')

      if (this.methods.length === 0)
        this.methods.push('click')

    },
    login(url) {
      window.location.href = process.env.VUE_APP_SPLASH_URL + url + '?token=' + this.token;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
